import React from "react";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";

const MiniTradeTable = ({ tradesList = [] }) => {
  const tableHeaderBg = useColorModeValue("gray.100", "gray.700");

  return (
    <TableContainer overflowY="auto" maxHeight="300px" rounded="lg">
      <Table size="sm" variant="simple">
        <Thead position="sticky" top={0} bg={tableHeaderBg}>
          <Tr>
            <Th>Trade Type</Th>
            <Th>Security Type</Th>
            <Th>Direction</Th>
            <Th>Ticker</Th>
            <Th isNumeric>PNL</Th>
            <Th isNumeric>% W/L</Th>
          </Tr>
        </Thead>
        <Tbody>
          {tradesList.map((trade, index) => (
            <Tr key={index}>
              <Td>{trade.trade_type}</Td>
              <Td>{trade.security_type}</Td>
              <Td>{trade.trade_direction}</Td>
              <Td>{trade.ticker_name}</Td>
              <Td isNumeric>{trade.pnl}</Td>
              <Td isNumeric>{trade.percent_wl}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default MiniTradeTable;
